"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const transformTokenForMode = (args, themeOptions) => {
    const { hex, oklch } = args;
    if (oklch && themeOptions?.colorOutputFormat !== "hex") {
        const components = `${Number(oklch.l.toFixed(4))} ${Number(oklch.c.toFixed(4))} ${Number(oklch.h?.toFixed(4) || 0)}`;
        const alphaSuffix = oklch?.alpha === undefined ? "" : ` / ${Number(oklch.alpha.toFixed(4))}`;
        return `oklch(${components}${alphaSuffix})`;
    }
    if (hex)
        return hex;
    throw new Error(`[Reshaped] ${JSON.stringify(args)} is missing a color value`);
};
const transformToken = (name, token, { themeOptions }) => {
    const { hex, hexDark, oklch, oklchDark } = token;
    // Apply color to both modes if dark mode is not available
    const hasDark = !!hexDark || !!oklchDark;
    const value = transformTokenForMode({ oklch, hex }, themeOptions);
    const darkValue = hasDark
        ? transformTokenForMode({ oklch: oklchDark, hex: hexDark }, themeOptions)
        : undefined;
    const separateModes = hasDark && value !== darkValue;
    const defaultMode = separateModes ? "light" : undefined;
    const result = [
        {
            name,
            tokenType: "color",
            type: "variable",
            value,
            mode: defaultMode,
        },
    ];
    if (darkValue && separateModes) {
        result.push({
            name,
            tokenType: "color",
            type: "variable",
            value: darkValue,
            mode: "dark",
        });
    }
    return result;
};
exports.default = transformToken;
